var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "px-4 py-2 text-xs text-primary-700 text-center" },
    [
      _c(
        "div",
        {
          staticClass: "flex max-w-content mx-auto",
          class:
            _vm.$viewer.isActive || !_vm.$auth.loggedIn
              ? "justify-center"
              : "justify-end"
        },
        [
          _c(
            "button",
            {
              staticClass: "mr-1 hover:underline hover:text-primary-900",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$ui.openFileMarkdownModal("about")
                }
              }
            },
            [_vm._v(" about ")]
          ),
          _vm._v(" | "),
          _c(
            "BaseLink",
            {
              staticClass: "mx-1",
              attrs: {
                title: "View application source code",
                url: _vm.$app.sourceUrl
              }
            },
            [_vm._v(" source ")]
          ),
          _vm._v(" | "),
          _c(
            "BaseLink",
            {
              staticClass: "mx-1",
              attrs: {
                title: "View application source code",
                url: _vm.$app.releaseNotesUrl
              }
            },
            [_vm._v(" " + _vm._s(_vm.$app.versionName) + " ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }